import React from "react";
import SkillsMenu from "../components/Skills/SkillsMenu";
import Slide from "react-reveal/Slide";

const SkillsPage = () => {
  return (
    <Slide bottom>
      <SkillsMenu />
    </Slide>
  );
};

export default SkillsPage;
